<template>
  <div class="team-sign-up">
    <div class="hd">
      <div class="fl">
        <el-select v-model="searchFormData.year" placeholder="所属学年" clearable>
          <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="searchFormData.term" placeholder="所属学期" clearable>
          <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <remote-search :options="org_id" @input="value => change(value, 'org_id')" :isCache="true" />
        <remote-search
          :options="specialized_subject_id"
          :paramsData="{ org_id: searchFormData.org_id }"
          ref="spec"
          @input="value => change(value, 'specialized_subject_id')"
          :isCache="true"
        />
        <el-input placeholder="班级名称" v-model="searchFormData.query"></el-input>
        <remote-search
          :options="teacher_id"
          ref="teach"
          @input="value => change(value, 'teacher_id')"
          :isCache="true"
        />
      </div>
      <el-button type="primary" @click="search">查 询</el-button>
    </div>
    <div class="content">
      <div class="class-list">
        <ly-table
          :getTableData="getTableData"
          :tableHeader="tableHeader"
          :searchFormData="searchFormData"
          :paginConfig="paginConfig"
          :tableConfig="tableConfig"
          ref="lyTable"
        >
          <!-- <template v-slot:sc="row">
            <el-button @click="showSc(row)" type="text" size="mini">查看</el-button>
          </template> -->
          <template v-slot:sc="row">
            <div v-html="classTimeSpTeam(row)"></div>
          </template>
          <template v-slot:teacher="row">
            {{ row.teacher | teacherFilter }}
          </template>
        </ly-table>
      </div>
      <div class="choose">
        <ly-transfer
          v-model="chooseStudent"
          @left-check-change="leftChange"
          :filter-method="filterMthod"
          filterable
          :titles="['老班学员', '新班学员']"
          :props="{
            key: 'contact_id',
            label: 'name'
          }"
          :format="{
            noChecked: `可报名额：${allowNum}`,
            hasChecked: '${checked}/' + allowNum
          }"
          :data="uniqCurClassStudents"
          :ifAdd="ifAdd"
          ref="transfer"
        >
          <el-button class="m-l-5" slot="left-footer" @click.native="removeCurStudents" size="small"
            >批量移除</el-button
          >
          <el-button class="m-l-5" slot="left-footer" @click.native="removeAllStudents" size="small"
            >移除全部</el-button
          >
          <p class="choose-info" slot-scope="{ option }">
            <span :class="option.delete_flag ? 'red' : ''">
              {{ option.name }}/{{ option.id_card_no }}/{{ option.phone }}/{{
                option.delete_flag
                  ? `(${option.delete_flag_label})`
                  : option.audit_status === 2
                  ? '(已实名)'
                  : '(未实名)'
              }}
            </span>
            <el-tooltip
              class="item"
              v-show="option.delete_flag"
              effect="light"
              content="已删除，请联系教务报名"
              placement="top"
            >
              <i class="el-icon-warning-outline red"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="点击复制" placement="top">
              <i class="el-icon-copy-document" @click.stop.prevent="copy(option)"></i>
            </el-tooltip>
          </p>
        </ly-transfer>
      </div>
    </div>
    <el-dialog title="课程表" append-to-body :visible.sync="dialogVisibleSc" width="1400px">
      <class-schedule :class_mode="scTime.class_mode" :class_id="scTime.class_id" />
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, Input, Select, Option, Tooltip } from 'element-ui';
import LyTable from '@/components/LyTable';
import ClassSchedule from '@/components/ClassSchedule';
import { contact } from '@/api';
import { org_id, specialized_subject_id, teacher_ids } from '@/utils/formConfigCommon';
import RemoteSearch from '@/components/common/RemoteSearch';
import classMixin from '@/utils/classMixin';

import LyTransfer from './LyTransfer';

const clipboard = require('clipboard-copy');

export default {
  name: 'TeamSignUp',
  components: {
    LyTable,
    ClassSchedule,
    ElDialog: Dialog,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    LyTransfer,
    RemoteSearch,
    ElTooltip: Tooltip
  },
  mixins: [classMixin],
  props: {
    row: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      searchFormData: {
        class_id: this.row.id,
        year: '2020',
        term: 3,
        query: '',
        org_id: '',
        specialized_subject_id: '',
        teacher_id: ''
      },
      tableHeader: [
        {
          option: {
            type: 'selection'
          }
        },
        {
          value: 'name',
          name: '班级名称'
        },
        {
          value: 'class_code',
          name: '代码'
        },
        {
          value: 'teacher',
          name: '老师'
        },
        {
          value: 'sc',
          name: '课程表'
        }
      ],
      paginConfig: {
        page_size: 10
      },
      tableConfig: {
        action: {
          'selection-change': selection => {
            this.getStudents(selection);
          },
          select: (selection, row) => {
            this.removeStudents(selection, row);
          },
          'select-all': selection => {
            if (selection.length === 0) {
              this.removeStudents(this.allSelection);
              return;
            }
            this.allSelection = [...selection];
          }
        }
      },
      getTableData: contact.groupSignUpClass,
      allSelection: [],
      scTime: {},
      dialogVisibleSc: false,
      years: [],
      terms: [],
      leftKeys: [],
      chooseStudent: [],
      curClassId: [],
      curClassStudents: [],
      searchId: '',
      org_id: {
        ...org_id.options,
        key: 'org_id',
        clearable: true
      },
      specialized_subject_id: {
        ...specialized_subject_id.options,
        key: 'specialized_subject_id',
        clearable: true
      },
      teacher_id: {
        ...teacher_ids.options,
        multiple: false,
        key: 'teacher_id',
        clearable: true,
        placeholder: '教师关键字检索'
      },
      paramsData: {},
      real_quota: 0,
      classNames: []
    };
  },
  computed: {
    uniqCurClassStudents() {
      // 去重
      const tmp = {};
      return this.curClassStudents
        .filter(item => {
          if (tmp[item.contact_id]) return false;
          tmp[item.contact_id] = true;
          return true;
        })
        .map(item => ({ ...item, disabled: item.audit_status !== 2 || item.delete_flag }));
    },
    allowNum() {
      const num = this.real_quota - this.chooseStudent.length;
      return num > 0 ? num : 0;
    },
    ifAdd() {
      return this.allowNum >= this.leftKeys.length;
    }
  },
  filters: {
    teacherFilter(value) {
      return (value || []).map(item => item.real_name).join(',');
    }
  },
  watch: {
    row() {
      this.init();
    }
  },
  mounted() {
    this.init();
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
        this.terms = data.term;
      }
    });
  },
  methods: {
    copy(option) {
      clipboard(`${option.name}/${option.id_card_no}/${option.phone}`);
      this.$message.success('复制成功');
    },
    filterMthod(query, data) {
      if (!query) return data;
      return data.name.includes(query) || data.id_card_no.includes(query) ? data : null;
    },
    init() {
      this.search();
      // this.$refs.transfer.$refs.rightPanel.$props
    },
    resetFields() {
      this.curClassId = [];
      this.curClassStudents = [];
      this.chooseStudent = [];
      this.$refs.lyTable.resetFields();
    },
    change(value, key) {
      if (key === 'org_id' && this.searchFormData[key] !== value) {
        this.$refs.spec.clear();
      }
      this.searchFormData[key] = value;
    },
    search() {
      this.$refs.lyTable.setData();
      contact.getGroupQuota({ class_id: this.row.id }).then(res => {
        if (res) {
          this.real_quota = res.data;
        }
      });
      console.log(this.curItem);
    },
    getStudents(selection) {
      const nowIds = selection.filter(item => !this.curClassId.includes(item.id)).map(item => item.id);
      this.classNames = selection.filter(item => nowIds.includes(item.id)).map(item => item.name);
      if (!nowIds.length) {
        return;
      }
      contact
        .groupSignUpStudent({
          params: {
            ids: nowIds,
            page_size: 200,
            page_no: 1
          }
        })
        .then(res => {
          this.curClassId = [...new Set([...this.curClassId, nowIds])];
          this.curClassStudents = [...new Set([...this.curClassStudents, ...res.data.list])];
          // this.curClassStudents = res.data.list;
        });
    },
    showSc(row) {
      this.scTime = {
        class_id: row.id
      };
      this.dialogVisibleSc = true;
    },
    getSelectStudents() {
      // 获取穿梭框的确认的值
      return {
        contact_ids: this.chooseStudent,
        classNames: this.classNames
      };
    },
    leftChange(keys) {
      if (this.allowNum < keys.length) {
        this.$message.warning('已超出班级剩余名额！');
      }
      this.leftKeys = keys;
    },
    removeCurStudents() {
      this.curClassStudents = this.curClassStudents.filter(item => !this.leftKeys.includes(item.contact_id));
      // 移除操作后注意重置状态
      this.leftKeys = [];
      this.curClassId = [];
    },
    removeAllStudents() {
      this.curClassStudents = [];
      // 移除操作后注意重置状态
      this.leftKeys = [];
      this.curClassId = [];
    },
    removeStudents(selection, row) {
      let isIn = false;
      let ids = [];
      if (row) {
        isIn = selection.find(item => item.id === row.id);
        ids = [row.id];
      } else {
        ids = selection.map(item => item.id);
      }
      if (!isIn) {
        contact
          .groupSignUpStudent({
            params: {
              ids,
              page_size: 200,
              page_no: 1
            }
          })
          .then(res => {
            if (res && res.data) {
              this.curClassStudents = this.curClassStudents.filter(item => {
                if (res.data.list.find(cur => cur.id === item.id)) {
                  return false;
                }
                return true;
              });
            }
          });
      }
    }
  }
};
</script>
<style lang="less">
.team-sign-up {
  .el-transfer {
    height: 100%;
  }
  .el-transfer-panel__body {
    height: calc(100% - 100px);
  }
  .right-panel .el-transfer-panel__body {
    height: calc(100% - 54px);
  }
  .content {
    display: flex;
    justify-content: space-between;
    position: relative;
  }
  .choose {
    position: absolute;
    height: 100%;
    left: 499px;
  }
  .class-list {
    width: 500px;
    min-height: 500px;
    margin: 0;
    border: 1px solid #ebeef5;
    padding: 15px;
    .hd .el-input {
      width: auto;
      margin: 0 5px;
    }
  }
  .hd {
    overflow: hidden;
    margin-bottom: 10px;
    .fl {
      display: flex;
      > * {
        margin-right: 10px;
        flex: 1;
        width: 181px;
      }
      .ly-search-comp .el-input {
        width: auto;
      }
    }
  }
  .choose {
    .el-input {
      width: auto;
    }
    .el-transfer-panel {
      height: 100%;
      width: 420px;
      .el-transfer-panel__list.is-filterable {
        height: 100%;
        padding-top: 1px;
      }
      .el-input__inner {
        width: 380px;
      }
      .el-transfer-panel__item.el-checkbox {
        .el-checkbox__input {
          top: -1px;
        }
        .el-checkbox__label {
          line-height: 1;
          white-space: initial;
          text-overflow: initial;
          font-size: 12px;
        }
      }
    }
    .choose-info {
      display: inline;
      .el-icon-warning-outline {
        margin-right: 8px;
      }
      .el-icon-copy-document {
        color: #333;
        cursor: pointer;
      }
    }
  }
  .el-transfer__button {
    display: block;
    margin: 0 auto;
    padding: 10px;
    border-radius: 50%;
    font-size: 0;
    margin-bottom: 10px;
  }
}
</style>
